import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoGoogle = () => {
  return (
    <g>
      <path d="M8.269.001a8.072 8.072 0 0 1 5.515 2.037l.153.14-1.564 1.579A5.876 5.876 0 0 0 8.35 2.184 5.959 5.959 0 0 0 4.14 3.89a5.656 5.656 0 0 0-1.692 3.947v.178a5.643 5.643 0 0 0 1.7 4.1 5.949 5.949 0 0 0 4.194 1.694c2.415 0 4.972-1.256 5.312-4.192l.017-.162H8.267V7.28h7.593c.1.475.146.959.136 1.443a6.946 6.946 0 0 1-2.163 5.265 7.333 7.333 0 0 1-5.445 2.003C3.802 16.03.049 12.444 0 7.976.084 3.575 3.75.04 8.269.001z" />
    </g>
  );
};

export default withIcon(IconLogoGoogle);
